import React from 'react'
import './thank-you-for-submitting.css'

const ThankYouForSubmitting = (props) => {
    return(
        <div className="thank-you-for-submitting-wrapper" onClick={() => props.setThankYouForSubmitting(false)}>
            <div className="thank-you-for-submitting-popup">
                <h4>Thank you for submitting your timesheet!</h4>
                <h5>We have received it.</h5>
            </div>
        </div>
    )
}
export default ThankYouForSubmitting